module.exports = __webpack_public_path__ + "static/media/station.bfb13691.jpg";